import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios";
// utils

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  fetchLoading: false,
  promoCodes: {
    data: [],
    meta: {
      total: 0,
    },
  },
};

// TODO: fetch all the promoCodes
export const fetchPromoCodes = createAsyncThunk(
  "fetchPromoCodes/promoCodes",
  async (
    { enqueueSnackbar, limit = 20, page = 0, filter, search },
    thunkApi
  ) => {
    try {
      const response = await axiosInstance.get(`settings/promo-code`, {
        params: {
          page: page + 1,
          limit,
          ...(filter &&
            filter.status && {
              status: filter.status,
            }),
          ...(search !== "" && {
            search,
          }),
        },
      });

      return {
        data: response.data.data.items,
        meta: {
          total: response.data.data.items.length,
        },
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: create promoCode
export const createPromoCode = createAsyncThunk(
  "createPromoCode/promoCodes",
  async ({ data, enqueueSnackbar, handleClose }, thunkApi) => {
    try {
      const response = await axiosInstance.post(`settings/promo-code`, data);

      return {
        data: response.data.data,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: update promoCode
export const updatePromoCode = createAsyncThunk(
  "updatePromoCode/promoCodes",
  async ({ data, enqueueSnackbar, handleClose, id }, thunkApi) => {
    try {
      const response = await axiosInstance.put(
        `settings/promo-code/${id}`,
        data
      );

      return {
        data: response.data.data,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: update promoCode status
export const updatePromoCodeStatus = createAsyncThunk(
  "updatePromoCodeStatus/promoCodes",
  async ({ id, status, enqueueSnackbar }, thunkApi) => {
    try {
      const response = await axiosInstance.patch(`settings/promo-code/${id}`, {
        status,
      });

      return {
        id,
        status,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: delete promoCode
export const deletePromoCode = createAsyncThunk(
  "deletePromoCode/promoCodes",
  async ({ enqueueSnackbar, handleClose, id }, thunkApi) => {
    try {
      await axiosInstance.delete(`settings/promo-code/${id}`);
      return {
        data: id,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

const promoCodeSlice = createSlice({
  name: "promoCode",
  initialState,
  extraReducers: (builder) => {
    // TODO: create promoCode
    builder.addCase(fetchPromoCodes.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchPromoCodes.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.isLoading = false;
      state.promoCodes = action.payload;
    });

    builder.addCase(fetchPromoCodes.rejected, (state, action) => {
      state.isLoading = false;
      state.fetchLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });

    // TODO: create promoCode
    builder.addCase(createPromoCode.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(createPromoCode.fulfilled, (state, action) => {
      state.isLoading = false;
      state.promoCodes.data = [action.payload.data, ...state.promoCodes.data];
      state.promoCodes.meta.total = state.promoCodes.meta.total + 1;
      action.payload.enqueueSnackbar("PromoCode is created successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(createPromoCode.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });

    // TODO: update promoCode
    builder.addCase(updatePromoCode.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(updatePromoCode.fulfilled, (state, action) => {
      state.isLoading = false;
      state.promoCodes.data = state.promoCodes.data.map((promoCode) => {
        if (promoCode.id === action.payload.data.id) {
          return action.payload.data;
        } else {
          return promoCode;
        }
      });
      action.payload.enqueueSnackbar &&
        action.payload.enqueueSnackbar("PromoCode is updated successfully.", {
          variant: "success",
        });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(updatePromoCode.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar &&
        action.payload.enqueueSnackbar(
          JSON.stringify(
            action.payload.error ||
              action.payload.error.errors ||
              action.payload.error.message
          ),
          {
            variant: "error",
          }
        );
    });

    // TODO: update promoCode status
    builder
      .addCase(updatePromoCodeStatus.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updatePromoCodeStatus.fulfilled, (state, action) => {
        state.isLoading = false;

        // Find and update the specific promoCode's status
        const promoCodeToUpdate = state.promoCodes.data.find(
          (promoCode) => promoCode.id === action.payload.id
        );
        if (promoCodeToUpdate) {
          promoCodeToUpdate.status = action.payload.status;
        }

        // Optional: Show success notification
        action.payload.enqueueSnackbar(`Promo Code status updated successfully`, {
          variant: "success",
        });
      })
      .addCase(updatePromoCodeStatus.rejected, (state, action) => {
        state.isLoading = false;
        action.payload.enqueueSnackbar(
          action.payload.error.message || "Failed to update promo code status",
          { variant: "error" }
        );
      });

    // TODO: delete promoCode
    builder.addCase(deletePromoCode.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(deletePromoCode.fulfilled, (state, action) => {
      state.isLoading = false;
      state.promoCodes.data = state.promoCodes.data.filter(
        (promoCode) => promoCode.id !== action.payload.data
      );
      action.payload.enqueueSnackbar("PromoCode is deleted successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(deletePromoCode.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });
  },
});

export default promoCodeSlice.reducer;
